import { regex } from './common'
export default regex('firstCharacter', /^([A-Za-z]{1})+[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ | {},.:;?¿¡!"()@\-_Ð><><»«*#%&$?!"?+\d\s\][]*$/)